import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const url = new URL(window.location.href);
let action = url.searchParams.get("action");

if (!action && url.hash.includes("?")) {
  const hashQuery = url.hash.split("?")[1];
  action = new URLSearchParams(hashQuery).get("action");
}

if (action === "logout") {
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem("url_logout", "true");
  url.searchParams.delete("action");
  window.history.replaceState(
    {},
    document.title,
    url.pathname + url.search + "#/"
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
